import * as yup from "yup";

import { addKeyToFieldsRecursively } from "@/react/schema/schemaFields";

const schema = yup.object({
  blfId: yup.string(),
  enablePickup: yup.boolean(),
  branchId: yup.string(),
  deviceBindingId: yup.string(),
  extensionNumber: yup.string(),
  customerId: yup.string(),
  destination: yup.string(),
  name: yup.string(),
  lastUpdatedTime: yup.date(),
  label: yup.string(),
  "Branch Name": yup.string(),
  deviceId: yup.string(),
});

addKeyToFieldsRecursively(schema);

export default schema;
